import { Box, Stack, Text } from "@chakra-ui/react";
import type { ReactNode } from "react";

export const MarketDialogueFormSection = ({ heading, children }: { heading: string; children: ReactNode }) => (
  <Box as="section" borderWidth="1px" borderRadius="lg" p="5">
    <Text as="h2" fontWeight="bold" fontSize="md" mb="4">
      {heading}
    </Text>
    <Stack spacing="6">{children}</Stack>
  </Box>
);
